// components/workSection.jsx
import React, { useState } from 'react';
import './styles/workSection.css';

const WorkSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      title: "AI-Driven Experiences",
      description: "We design intelligent interfaces that feel natural, fast, and personalized.From automation layers to predictive flows, we integrate AI in a way that enhances clarity, user behavior, and business results.",
      category: "AI-Prompt",
      image: "/project1.png"
    },
    {
      title: "Digital Product Design",
      description: "Web platforms, mobile apps, dashboards, and complex systems crafted with precision.We turn ideas into clean, functional, high-performance experiences built for real users.",
      category: "UX-UI Experience",
      image: "/project2.png"
    },
    {
      title: "Systems & Scalability",
      description: "Design systems, component libraries, and flexible frameworks that ensure consistency and long-term growth.We build the foundations that make your product strong, stable, and ready to evolve.",
      category: "Creativity",
      image: "/project3.png"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="work" className="work-section">
      <div className="work-container">
        <h2 className="work-title">Our Work</h2>
        <p className="work-subtitle">
          What we do best to help brands grow, scale, and innovate
        </p>

        <div className="carousel-container">
          <div className="carousel-wrapper">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`carousel-slide ${
                  index === currentSlide ? 'active' : ''
                }`}
              >
                <div className="slide-content">
                  <div className="slide-image">
                    {/* 👇 התמונה תופיע כאן! */}
                    {project.image && (
                      <img 
                        src={project.image} 
                        alt={project.title}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: '2rem',
                          position: 'absolute',
                          top: 0,
                          left: 0
                        }}
                      />
                    )}
                    <span className="slide-number">0{index + 1}</span>
                  </div>
                  <div className="slide-info">
                    <div className="slide-category">{project.category}</div>
                    <h3 className="slide-title">{project.title}</h3>
                    <p className="slide-description">{project.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide}>
            ←
          </button>
          <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide}>
            →
          </button>

          {/* Dots Navigation */}
          <div className="carousel-dots">
            {projects.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSection;